/**
 * The height used in the converter by default
 */
export const DEFAULT_CONVERTER_HEIGHT = 182;
